import { useReducer } from 'react';

function toggler(currentValue: boolean, newValue?: boolean) {
  return typeof newValue === 'boolean' ? newValue : !currentValue;
}

export function useToggle(initialValue = false) {
  return useReducer(toggler, initialValue);
}
